import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHistory = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_4810_20962)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M13.2857 4C9.02571 4 5.57143 7.45429 5.57143 11.7143H3L6.33429 15.0486L6.39429 15.1686L9.85714 11.7143H7.28571C7.28571 8.39714 9.96857 5.71429 13.2857 5.71429C16.6029 5.71429 19.2857 8.39714 19.2857 11.7143C19.2857 15.0314 16.6029 17.7143 13.2857 17.7143C11.6314 17.7143 10.1314 17.0371 9.05143 15.9486L7.83429 17.1657C9.23143 18.5629 11.1514 19.4286 13.2857 19.4286C17.5457 19.4286 21 15.9743 21 11.7143C21 7.45429 17.5457 4 13.2857 4ZM12.4286 8.28571V12.5714L16.0971 14.7486L16.7143 13.7114L13.7143 11.9286V8.28571H12.4286Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_4810_20962",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "currentColor"
		})
	}) })]
});
export default SvgHistory;
